import React from "react";
import Logo from "@/components/ui/logo";
import LogoImage from "@/../public/images/icons/Logo.png";
import { Button, Container, Spinner } from "react-bootstrap";
import LanguageSelectWrapper from "@/components/languageSelectWrapper";
import { List } from "react-bootstrap-icons";
import { BASE_URL } from "@/constants";

interface MobileHeaderProps {
  onOpenSidebar: () => void;
  branchLogo?: string | null;
  isLoading?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onOpenSidebar,
  branchLogo,
  isLoading = false,
}) => {
  const logoSrc = branchLogo ? `${BASE_URL}/${branchLogo}` : LogoImage;
  return (
    <header
      className="d-md-none fixed-top bg-white"
      style={{ height: "var(--app-header-height-mobile)" }}
    >
      <Container
        fluid
        className="h-100 position-relative d-flex align-items-center justify-content-between"
      >
        <Button
          type="button"
          variant="link"
          className="p-0"
          onClick={onOpenSidebar}
        >
          <List
            className="lh-1 text-text-primary fs-32"
            aria-hidden="true"
            focusable="false"
          />
        </Button>

        <div className="position-absolute top-50 start-50 translate-middle">
          {isLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Logo
              src={logoSrc}
              classNameImg={branchLogo ? "rounded-circle" : ""}
              height={branchLogo ? 45 : undefined}
            />
          )}
        </div>
        <LanguageSelectWrapper view="mobile" />
      </Container>
    </header>
  );
};

export default MobileHeader;
